import { UserRoleComponent } from './user-role-list.component';

export default UserRoleComponent;
